
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

/* ------------------------------------------------------------------
   Data for the statistic cards
------------------------------------------------------------------- */
const highlights = [
  {
    icon: "ri-car-line",
    stat: "3",
    label: "Véhicules Premium",
    desc: "Mercedes Classe E, V & S",
  },
  {
    icon: "ri-camera-lens-line",
    stat: "12+",
    label: "Photos Exclusives",
    desc: "Véhicules, services & destinations",
  },
  {
    icon: "ri-map-pin-line",
    stat: "20+",
    label: "Destinations",
    desc: "Stations, aéroports & gares",
  },
  {
    icon: "ri-star-line",
    stat: "7 ans",
    label: "d'Expérience",
    desc: "Depuis 2017, service premium",
  },
];

/* ------------------------------------------------------------------
   GalleryStats component
------------------------------------------------------------------- */
export default function GalleryStats() {
  /**
   * `useInView` from *react‑intersection‑observer* returns an **object**
   * `{ ref, inView, entry }`. The original code attempted to destructure it
   * as an array (`[ref, inView]`), which results in a syntax error and breaks
   * the component. The fix below uses the correct object destructuring.
   */
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  /**
   * Defensive rendering – if `ref` is unexpectedly undefined (for example,
   * if the hook fails), we still return a valid JSX tree without animation.
   */
  const animationProps = inView
    ? { opacity: 1, y: 0 }
    : { opacity: 0, y: 30 };

  return (
    <section
      ref={ref}
      className="py-16 sm:py-20 px-4 sm:px-6 lg:px-12 bg-gradient-to-br from-slate-50 to-white"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6">
          {highlights.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={animationProps}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-white rounded-2xl p-6 sm:p-8 text-center border border-slate-100 shadow-sm hover:shadow-lg transition-shadow"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-voyage-gold/10 rounded-xl mx-auto mb-4">
                <i className={`${item.icon} text-voyage-gold text-2xl`}></i>
              </div>
              <p className="font-playfair text-3xl sm:text-4xl font-bold text-night-blue mb-1">
                {item.stat}
              </p>
              <p className="font-inter text-sm font-semibold text-night-blue mb-1">
                {item.label}
              </p>
              <p className="font-inter text-xs text-slate-500">{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
